import React from 'react'
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskZip(props){
  const {onChange, inputRef, ...inputMaskProps} = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      mask="99999"
      onChange={onChange}
      maskChar=" "
    />
  )
}

InputMaskZip.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskZip.js